"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M18 8a2 2 0 1 0-1.133-.352l-2.68 5.36a2 2 0 0 0-1.104.214l-1.414-2.12a2 2 0 1 0-2.83.527L6.21 16.011a2 2 0 1 0 .95.36l2.63-4.382q.104.01.21.011c.33 0 .643-.08.918-.222l1.413 2.12a2 2 0 1 0 2.802-.546l2.68-5.36Q17.906 8 18 8"
}), 'SalesFilled');
//# sourceMappingURL=index.js.map